import { CheckCircle2, XCircle } from "lucide-react";

export const PumpKey = ({ children, onClick, testid, className = "", small }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    className={`rounded-lg bg-slate-600 hover:bg-slate-500 active:bg-slate-400 text-white font-bold transition-colors ${
      small ? "text-[10px] py-0.5" : "text-base py-2.5"
    } ${className}`}
  >
    {children}
  </button>
);

export const ScoreRow = ({ ok, label, target }) => (
  <div className="flex items-center gap-2" data-testid={`score-row-${label.toLowerCase().split(" ")[0]}`}>
    {ok ? (
      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0" />
    ) : (
      <XCircle className="w-3.5 h-3.5 text-red-400 shrink-0" />
    )}
    <span className="text-slate-300">{label}</span>
    <span className="ml-auto text-slate-400">
      {ok ? "correct" : `target ${target}`}
    </span>
  </div>
);
